"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";
import { Provider } from "react-redux";
import store from "../redux/store";
import { SidebarProvider } from "../components/ui/sidebar";
import { ThemeProvider } from "../components/theme-provider";
import SidebarWithPlan from "./sidebar-wrapper";
import { LanguageProvider } from "./contexts/languagecontext";

interface Props {
  children: ReactNode;
}

export default function LayoutContentClient({ children }: Props) {
  const pathname = usePathname();
  const isLoginPage = pathname === "/login";

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     // Clear session cookies
  //     document.cookie = 'token=; path=/; max-age=0'
  //     document.cookie = 'userData=; path=/; max-age=0'
  //     document.cookie = 'merchantData=; path=/; max-age=0'
  //   }

  //   window.addEventListener('beforeunload', handleBeforeUnload)
  //   return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  // }, [])

  return (
    <Provider store={store}>
      <ThemeProvider attribute="class" defaultTheme="light">
        <LanguageProvider>
          <SidebarProvider>
            {!isLoginPage && <SidebarWithPlan />}
            <main className="w-full">{children}</main>
          </SidebarProvider>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  );
}
